import { CancelIconButton, Grid, Stack, Tooltip, Typography, useElementBreakpoints } from "@compass/core";
import { BulkSelectedItemErrors, DataModel } from "generated/openApi";
import { memo } from "react";

export const BulkSelectedItems = memo(
  <T extends DataModel>(props: {
    gridView: boolean;
    items: Map<number, T>;
    getItemLabel: (item: T) => string;
    onRemove: (id: number) => void;
    errors: BulkSelectedItemErrors[];
    errorFilter: boolean;
  }) => {
    // console.log("BulkSelectedItems rerendered");
    const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

    const getItemErrors = (errors: string[], toolTip?: boolean) => {
      return (
        <>
          {errors.map((y, index) => {
            return (
              <Typography color={toolTip ? undefined : "error"} variant="caption">
                {errors.length > 1 ? index + 1 + ". " : ""}
                {y}
              </Typography>
            );
          })}
        </>
      );
    };

    return (
      <Grid ref={breakpointsRef} container spacing="xs">
        {Array.from(props.items).map(([key, item]) => {
          const errors = props.errors.find((x) => x.id === item.id)?.errors || [];
          const hasErrors = errors.length > 0;
          if (props.errorFilter && !hasErrors) return null;

          return (
            <Grid item xs={props.gridView ? setBreakpoints({ lg: 3, md: 4, sm: 6, xs: 12 }) : 12}>
              <Tooltip
                title={props.gridView && hasErrors ? getItemErrors(errors, true) : ""}
                color="error"
                sx={{ width: "100%" }}
              >
                <Stack
                  key={key}
                  width="100%"
                  direction="row"
                  spacing="md"
                  border={1}
                  borderColor={(theme) => (hasErrors ? theme.palette.error.dark : theme.palette.border.dark)}
                  alignItems="center"
                  justifyContent={"space-between"}
                  p={0.5}
                  sx={{
                    // "&:hover": { bgcolor: (theme) => theme.palette.background.default },
                    "&:not(:last-child)": {
                      borderBottom: "0", // Remove the bottom border for all stacks except the last one
                    },
                  }}
                >
                  <Stack direction="row" spacing="xs" alignItems="center" flexShrink={0}>
                    <CancelIconButton onClick={() => props.onRemove(item.id)} />
                    <Stack>{props.getItemLabel(item)}</Stack>
                  </Stack>

                  {!props.gridView && <Stack alignItems="flex-end">{getItemErrors(errors)}</Stack>}
                </Stack>
              </Tooltip>
            </Grid>
          );
        })}

        {/* <Stack>
          {Array.from(props.items).map(([key, item]) => {return (
            <BulkSelectedItem
              key={key}
              viewMode={props.viewMode}
              id={item.id}
              value={props.getItemLabel(item)}
              onRemove={remove}
              errors={props.errors.find((x) => x.id === item.id)?.errors}
            />
          )})}
        </Stack> */}
      </Grid>
    );
  }
);
